import { render, staticRenderFns } from "./CompanyCustomerSupportTwilioThreads.vue?vue&type=template&id=4c8dc982&"
import script from "./CompanyCustomerSupportTwilioThreads.vue?vue&type=script&lang=js&"
export * from "./CompanyCustomerSupportTwilioThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports